/** Grading levels for competency criteria (coloured tick boxes). */
export const GRADING_LEVELS = [
  "Unconscious competence",
  "Competent",
  "Aware, no practice",
  "Unaware",
] as const;

export type GradingLevel = (typeof GRADING_LEVELS)[number];

export interface CycleElement {
  id: string;
  title: string;
  demonstrate: string[];
  explain: string[];
}

export interface CycleUnit {
  id: string;
  title: string;
  elements: CycleElement[];
}

export interface Cycle {
  id: string;
  name: string;
  gradingLevels: readonly string[];
  units: CycleUnit[];
}
